import ScrollToTop from "../helpers/ScrollToTop";

export const Sources = () => {
  return (
    <div class="text-[#444444] pl-10 pr-10 pt-10 mb-40">
      <ScrollToTop />
      <p class="mb-5 font-serif italic text-2xl text-[#36556A]">
        Und wo bekomme ich jetzt so etwas her?
      </p>
      <p class="mb-5 font-serif text-4xl text-[#36556A]">Bezugsquellen</p>

      <p class="mb-5 font-sans">
        Ich würde tatsächlich empfehlen, einen Knitting Belt in Shetland zu bestellen.
        Einfach weil die Produktionskosten in D so hoch sind, dass man trotz Zollgebühren 1:1 dabei herauskommt im Vergleich zur Fertigung in D.
        Und zum Anderen wissen die Shetlander, wie ein Knitting Belt beschaffen sein muss -
        dass das Leder nicht zu hart sein darf (weil sich sonst die Nadeln zu schwer hineinstecken lassen)
        und dass er mit Rosshaar gefüllt sein sollte (andere Materialien werden schneller beschädigt, wenn man jahrelang Stricknadeln aus Edelstahl hineinsteckt).
      </p>

      <p class="mb-5">
        Es ist eine Investition, ja, das ist richtig. Aber wenn ihr das Stricken mit dem Knitting Belt beibehaltet, ist es eine gute Prophylaxe, um keine gesundheitlichen Probleme zu bekommen - und für das Garn eines Pullovers gibt man ja durchaus auch mal dreistellige Beträge aus (je nach Garnmenge und Faser).
      </p>

      <p class="mb-5">
        Bei der Anschaffung eines Knitting Belts müsst ihr circa mit 70-80 Euro rechnen.
        Wenn ihr in Shetland bestellt, sind die Belts zwar günstiger (um die 50 Pfund), aber es kommt wahrscheinlich Zoll hinzu
        (wieviel, weiß ich leider nicht).

        Wenn ihr in Deutschland bei einem Sattler einen in Auftrag gebt, kosten die Produktionskosten, so dass man hier auch bei 70-80 Euro landet.

        Und wenn man selbst bauen möchte und sich das Werkzeug zur Lederbearbeitung erst noch zulegen muss (spezielle Nadeln, Garn, Lochzange etc), landet man auch bei um die 70 Euro.
      </p>

      <p class="mb-5">
        Das hängt damit zusammen, weil es Rosshaar nur in 1 kg als kleinster Menge, die ich online gefunden habe, gibt.
        Und 1 kg Rosshaar kostet ungefähr 38 Euro (Stand Dezember 2025, wo wir noch im August 2024 bei 22 Euro lagen!). Benötigen tut man für einen einzigen Knitting Belt nur ca. 50 Gramm davon - man könnte sich also mit jemandem zusammentun.
        Günstiger ist es trotzdem nur marginal, und man hat ja auch noch seine eigene Arbeitszeit. Zu beachten: Das Rosshaar, das man als Füllmaterial verwendet, ist gekräuselt, weil es dann wie eine Sprungfeder wirkt. Es nützt also nicht viel, langes, glattes Rosshaar für Geigenbögen zu kaufen!
      </p>

      <p class="mb-5 font-sans text-[#36556A]">
        <a
          href="https://www.shetlandwoolbrokers.co.uk/knitting-belt-c2x35679733"
          class="font-medium text-[#2b7a8b] hover:text-[#02add2] hover:underline visited:text-[#02add2]"
          target="_blank"
          rel="noreferrer"
        >
          Jamieson &amp; Smith in Shetland (UK/Shetland)
        </a>
      </p>
      <p class="mb-5 font-sans text-[#36556A]">
        <a
          href="https://www.jamiesonsofshetland.co.uk/knitting-belt-1236-p.asp"
          class="font-medium text-[#2b7a8b] hover:text-[#02add2] hover:underline visited:text-[#02add2]"
          target="_blank"
          rel="noreferrer"
        >
          Jamieson´s of Shetland (UK/Shetland)
        </a>
      </p>
      <p class="mb-5 font-sans text-[#36556A]">
        <a
          href="https://www.lisasleatherworks.co.uk/product-page/traditional-shetland-knitting-belt"
          class="font-medium text-[#2b7a8b] hover:text-[#02add2] hover:underline visited:text-[#02add2]"
          target="_blank"
          rel="noreferrer"
        >
          Lisa´s Leatherworks (UK/Scotland/Dumfries &amp; Galloway)
        </a>
      </p>
      <p class="mb-5 font-sans text-[#36556A]">
        <a
          href="https://www.janettebudge.com/product/shetland-knitting-belt/"
          class="font-medium text-[#2b7a8b] hover:text-[#02add2] hover:underline visited:text-[#02add2]"
          target="_blank"
          rel="noreferrer"
        >
          Janette Budge (UK/Shetland/Mainland)
        </a>
        {" "}- auch Nadeln/DPNs
      </p>
      <p class="mb-5 font-sans text-[#36556A]">
        <a
          href="https://www.etsy.com/de/shop/BobNWeave"
          class="font-medium text-[#2b7a8b] hover:text-[#02add2] hover:underline visited:text-[#02add2]"
          target="_blank"
          rel="noreferrer"
        >
          Etsy / BobNWeave (USA/Minnesota)
        </a>
        {" "}- auch vegane Belts
      </p>
      <p class="mb-5 font-sans text-[#36556A]">
        <a
          href="https://www.etsy.com/shop/BygoneYarnyStuff"
          class="font-medium text-[#2b7a8b] hover:text-[#02add2] hover:underline visited:text-[#02add2]"
          target="_blank"
          rel="noreferrer"
        >
          Etsy / BygoneYarnyStuff (UK/Dorset)
        </a>
      </p>

      <p class="mt-10 mb-5 font-serif text-2xl text-[#36556A]">Nadelspiele</p>

      <p class="mb-5">
        Ich möchte auch hier nochmal erwähnen - ihr müsst NICHT mit 40 cm Nadeln starten!!! Das würde ich auch eher nicht empfehlen, denn sie sind durch ihre Länge wirklich gewöhnungsbedürftig. Auch Hazel Tindall hat mal irgendwo erwähnt, dass sie nicht gerne mit den 40 cm Nadeln strickt - die Shetlander nehmen für alles lieber 30 oder 35 cm.
      </p>
      <p class="mb-5">
        Tipp: Wenn man mit 35 cm Nadeln Pullover stricken möchte, kann man das Strickstück knapp unterhalb der Nadeln mit einem Nylonstrumpf zusammenbinden, so dass die Maschen nicht von den Nadeln fallen.
      </p>
      <p class="mb-5">
        ---
      </p>

      <p class="mb-5">
        Hersteller von langen Nadelspielen:
      </p>

      <p class="mb-5">
        Milward (Großbritannien)
        Double Pointed Knitting Pins: 30 cm Nadelspiele aus Aluminium, matt. 5 Nadeln pro Größe. Keine Zwischengrößen, zumindest habe ich keine gefunden, also nur 2 mm, 2,5 mm, 3 mm, usw.
      </p>
      <p class="mb-5">
        Im Shop von Jamieson &amp; Smith kann man diese bestellen.{" "}
        <a
          href="https://shetlandwoolbrokers.co.uk/products/30cm-double-pointed-needles"
          class="font-medium text-[#2b7a8b] hover:text-[#02add2] hover:underline visited:text-[#02add2]"
          target="_blank"
          rel="noreferrer"
        >
          Milward 30cm Double Pointed Needles bei Jamieson &amp; Smith
        </a>
        <br />
        Milward Nadeln habe ich in Shetland vor Ort gekauft und finde die Spitzen denen von addi überlegen. Milward ist ein britischer Hersteller und ist auch größtenteils nur in GB zu bekommen (= bedeutet: Zollgebühren). Teilweise hat man Glück auf Amazon (meist findet man dort aber nicht alle Größen), sucht dort evtl nach "Milward Doppelspitzen 30 cm", so dass ihr Nadelspiele findet und keine Jackennadeln mit einem Stopper, denn diese kann man für den Knitting Belt natürlich nicht verwenden.
      </p>
      <p class="mb-5">
        ---
      </p>

      <p class="mb-5">
        addi (Deutschland)
        Sock:  40 cm Nadelspiele aus Aluminium, matt. 5 Nadeln pro Größe. Auch Zwischengrößen wie 3,25 mm oder 3,75 mm. Es kann sein, dass sie von addi nicht mehr produziert werden, weil ich auf ihrer Haupt-Webseite addi.de keine Nadelspiele, die länger als 23 cm sind, mehr in ihrer Angebotspalette gesehen habe (Stand Dezember 2025).
      </p>
      <p class="mb-5">
        Da addi aus Deutschland kommen, bestellt sie am Besten auch hier in D bei Country Creativ oder so, damit ihr keine Zollgebühren zahlt!{" "}
        <a
          href="https://country-creativ.de/Stricknadeln/Nadelspiele/addi-Alu:::448_13_1134.html"
          class="font-medium text-[#2b7a8b] hover:text-[#02add2] hover:underline visited:text-[#02add2]"
          target="_blank"
          rel="noreferrer"
        >
          addi Alu Nadelspiele bei Country Creativ
        </a>
      </p>

      <p class="mb-5">
        ---
      </p>

      <p class="mb-5">
        Prym (Deutschland)
        Strumpfstricknadeln, perlgrau: 30 und 40 cm Nadelspiele aus Aluminium, matt. 5 Nadeln pro Größe.
        <br />
        <a
          href="https://www.prym.com/de/strumpfstricknadeln-perlgrau"
          class="font-medium text-[#2b7a8b] hover:text-[#02add2] hover:underline visited:text-[#02add2]"
          target="_blank"
          rel="noreferrer"
        >
          Prym Strumpfstricknadeln perlgrau (prym.com)
        </a>
      </p>

      <p class="mb-5">
        ---
      </p>

      <p class="mb-5">
        Pony (Indien)
        Classic: 30 nd 40 cm Nadelspiele aus Aluminium, matt. 5 Nadeln pro Größe. Auch Zwischengrößen wie 3,25 mm oder 3,75 mm.
      </p>

      <p class="mb-5">
        Da sich die 30 cm Nadelspiele von Milward, Prym und Pony alle stark ähneln, von den Spitzen und auch von der Haptik her, vermute ich mal ganz stark, diese sind eventuell alle in Indien von demselben Hersteller produziert.
        Um mein 30-cm-Set von Milward zu ergänzen, habe ich zwei Größen (3,25 mm und 3,75 mm) von Pony bei Amazon bestellt. Hier an dieser Stelle kein Link, weil sich die Links bei Amazon auch öfter ändern können.
      </p>

      <p class="mb-5">
        ---
      </p>

      <p class="mb-5">
        No-name aus Asien
        ca. 25 cm und ca. 36 cm Nadelspiele aus Edelstahl, glänzend (das kann bei Deckenbeleuchtung etwas nervig sein). Auch Zwischengrößen, manchmal sind nicht alle Größen bei einem Set dabei. 4 Nadeln pro Größe.
        Die Spitzen der Nadeln aus Asien sind definitiv nicht für kompliziertes Lace geeignet, weil sie zu stumpf dafür sind. Aber normale, einfache Umschläge / yarnovers gehen damit auch. Zweifarbig stricken geht auch - ich nehme diese Nadeln nach wie vor gerne. Zum Einstieg auch super geeignet, weil nicht teuer. Evtl bestellt man sich gleich zwei Sets, falls man mal eine Nadel verlegt, denn bei nur 4 Nadeln pro Größe kann das schon bedeuten, dass man eine ganze Größe nicht mehr benutzen kann.
        Weil diese asiatischen Nadeln nicht so gut zu finden sind im Netz, hier zwei Quellen:
      </p>
      <p class="mb-5">
        Bei Amazon:{" "}
        <a
          href="https://www.amazon.de/St%C3%BCck-Stricknadeln-Doppelstricknadeln-Edelstahl-Pullover/dp/B07SV2LH54/ref=sr_1_8?__mk_de_DE=%C3%85M%C3%85%C5%BD%C3%95%C3%91&crid=QDFDU75C3QL0"
          class="font-medium text-[#2b7a8b] hover:text-[#02add2] hover:underline visited:text-[#02add2]"
          target="_blank"
          rel="noreferrer"
        >
          44-tlg. Edelstahl-Nadelspiel-Set 36cm bei Amazon.de
        </a>
      </p>
      <p class="mb-5">
        Bei Ali Xpress, der Händler nennt sich "Pr-allsion Store". Bei Ali Xpress kann man nur mit Kreditkarte zahlen, soweit ich weiß. Meine ersten Nadeln kamen von hier. Versandkosten sind verschwindend gering. Lieferzeiten beachten, es kann etwas dauern:{" "}
        <a
          href="https://de.aliexpress.com/item/4000744800714.html?%20spm=a2g0n.productlist.0.0.17161b24hYu105&browser_id=3a46832b742a46e5920901aeefb878df&aff_trace_key=&aff_platform=msite&m_page_id=001186464a%2037fd-4fd1-8377-bc8a41afbb09"
          class="font-medium text-[#2b7a8b] hover:text-[#02add2] hover:underline visited:text-[#02add2]"
          target="_blank"
          rel="noreferrer"
        >
          35-tlg. Edelstahl-Nadelspiel-Set bei AliExpress
        </a>
      </p>

      <p class="mb-5">
        ---
      </p>
      <p class="mb-5">
        Bei den anderen Anbietern bitte ich um Verständnis, dass ich nicht alle Onlineshops aufführen kann, die längere Nadelspiele führen, einfach weil man tatsächlich etwas danach suchen muss. Mein Tipp wäre, einfach danach zu googeln. Die Suchbegriffe "Hersteller" (zB addi), "Länge" (zB 40 cm), "Nadelspiel" oder "Strumpfstricknadel" werden euch sicher Möglichkeiten auflisten.
      </p>
      <p class="mb-5">
        ---
      </p>
      <p class="mb-5">
        Für Lace-Liebehaberinnen und -Liebhaber noch eine besonderer Tipp: Die Hiya Hiya Sharps kann man sich zusammen mit den Hiya Hiya Straight Sets zu langen DPNs "zusammenschrauben". Dann hat man wunderbar spitze Nadelspitzen, mit denen man auch ein p2tog-tbl (purl 2 together through the back loop) hinkriegt. Ich habe damit mein "Rheinlust" Tuch von Melanie Berg gestrickt. Allerdings ist die Lösung etwas teurer, leider, und ein ganzes Nadelspiel von vier Nadeln wird man sich davon vermutlich nicht leisten wollen.
      </p>
      <p class="mb-5">
        Und man sollte auch auf die nicht-zum-Stricken-verwendete Seite eine Spitze schrauben, da sonst die Nadel vom Belt nicht so gut gehalten wird. Aber das kann ja dann eine Nadel in einer anderen Größe sein, sie muss nur in den Knitting Belt passen.
      </p>
      <p class="mb-5">
        <a
          href="https://country-creativ.de/Stricknadeln/Auswechselbare-Spitzen/HiyaHiya-Sharp:::448_1082_1113.html"
          class="font-medium text-[#2b7a8b] hover:text-[#02add2] hover:underline visited:text-[#02add2]"
          target="_blank"
          rel="noreferrer"
        >
          HiyaHiya Sharp Spitzen bei Country Creativ
        </a>
        <br />
        <a
          href="https://country-creativ.de/Stricknadeln/Jackenstricknadeln/HiyaHiya-Straight-Needles:::448_174_370.html"
          class="font-medium text-[#2b7a8b] hover:text-[#02add2] hover:underline visited:text-[#02add2]"
          target="_blank"
          rel="noreferrer"
        >
          HiyaHiya Straight Needles bei Country Creativ
        </a>
      </p>
    </div>
  );
};
